import { render, staticRenderFns } from "./GlobalDialog.vue?vue&type=template&id=ba07b2a4&scoped=true"
import script from "./GlobalDialog.vue?vue&type=script&lang=js"
export * from "./GlobalDialog.vue?vue&type=script&lang=js"
import style0 from "./GlobalDialog.vue?vue&type=style&index=0&id=ba07b2a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba07b2a4",
  null
  
)

export default component.exports